import React from 'react';
import { FormLayoutComposer, IFormLayoutProps } from 'components/common/form/renderer/FormLayoutComposer';

import { ActAfterSaveSuccess } from 'components/common/form/act';

export default function ChangeEmailForm(props: IFormLayoutProps) {
    props.hookForm.form.formAct.overrideAct(
        'afterSaveSuccess',
        class extends ActAfterSaveSuccess {
            async exec(response: any, data: any): Promise<any> {
                window.setTimeout(() => window.location.reload(), 100);
                return super.exec(response, data);
            }
        },
    );

    return <FormLayoutComposer props={props} />;
}
